import React from 'react';
import { CopyText as CopyTextNew } from './CopyText';
import { convertOldCopyTextProps } from './converter.old';
import type { OldCopyTextProps } from './converter.old';

export type CopyTextProps = OldCopyTextProps;

export const CopyText = React.forwardRef<HTMLButtonElement, CopyTextProps>((props, ref) => (
  <CopyTextNew {...convertOldCopyTextProps(props)} ref={ref} />
));
